// js
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedNumber } from 'react-intl';
import ProgressBar from '../common/ProgressBar';
// css
import '../../styles/components/analytics/OverviewIndexedDataSummary.scss';


function OverviewIndexedDataSummary({
  progressBarStripeColor = 'black',
  progressBarHeight = 40,
  compact = false,
  stats,
  indexedPerDayFormatter
}) {

  const configuredItems = (
    <div className='analytics__overview-indexed-data-summary__configured-items'>{stats.configuredItems} Configured items</div>
  );

  const totalRequiredPerDay = (
    <div className='analytics__overview-indexed-data-summary__total-required-per-day'>
      <FormattedNumber value={stats.dataIndexed} maximumFractionDigits={1} /> of&nbsp;
      <span className='analytics__overview-indexed-data-summary__total-gb-per-day'>
        <FormattedNumber value={stats.dataRequired} maximumFractionDigits={1} /> GB
      </span>&nbsp;Total Required Data Per Day
    </div>
  );

  const indexedPerDayText =
    indexedPerDayFormatter ?
    indexedPerDayFormatter(stats.percentIndexed) :
    `${stats.percentIndexed}% indexed per day`;

  const indexedPerDay = (
    <p className='analytics__overview-indexed-data-summary__indexed-per-day'>
      {indexedPerDayText}
    </p>
  );

  const progressBar = (
    <ProgressBar
      height={progressBarHeight}
      stripeColor={progressBarStripeColor}
      percent={stats.percentIndexed / 100}
    />
  );

  const ciscoSplit = (
    <div className='analytics__overview-indexed-data-summary__cisco-split'>
      <div>
        <FormattedNumber value={stats.nonCiscoDataPerDay} maximumFractionDigits={1} /> GB/day Non Cisco
        &nbsp;&middot;&nbsp;
        <FormattedNumber value={stats.ciscoDataPerDay} maximumFractionDigits={1} /> GB/day Cisco Data
      </div>
      <div className='analytics__overview-indexed-data-summary__cisco-indexed'>
        <FormattedNumber value={stats.nonCiscoDataIndexed} maximumFractionDigits={1} /> GB/day indexed Non Cisco ({stats.nonCiscoPercentIndexed}%)
        &nbsp;&middot;&nbsp;
        <FormattedNumber value={stats.ciscoDataIndexed} maximumFractionDigits={1} /> GB/day indexed Cisco Data ({stats.ciscoPercentIndexed}%)
      </div>
    </div>
  );

  if (compact) {
    return (
      <div
        className={classnames(
          'analytics__overview-indexed-data-summary',
          'analytics__overview-indexed-data-summary--compact'
        )}
      >
        <div className='row'>
          <div className='col-md-6'>
            {totalRequiredPerDay} &middot; {configuredItems}
            {ciscoSplit}
          </div>
          <div className='col-md-6'>
            {progressBar}
            {indexedPerDay}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='analytics__overview-indexed-data-summary'>
      {configuredItems}
      {totalRequiredPerDay}
      {ciscoSplit}
      {progressBar}
      {indexedPerDay}
    </div>
  );
}

OverviewIndexedDataSummary.propTypes = {
  stats: PropTypes.object.isRequired,
  compact: PropTypes.bool,
  progressBarStripeColor: PropTypes.string,
  progressBarHeight: PropTypes.number,
  indexedPerDayFormatter: PropTypes.func
};

export default OverviewIndexedDataSummary;



// WEBPACK FOOTER //
// ./src/components/analytics/OverviewIndexedDataSummary.js